import comp from "./CollaboratorV2AddEditModal";
export default comp;
